// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__bC7-F","title":"Images90_title__3PtqM","images":"Images90_images__-tVtM"};